import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledLightningLinkMainProduct } from './style';
import { TooltipRenderer } from 'components/TooltipTemplate/TooltipRenderer';
import { IProductResponse } from 'utils/types';
import { CSSProperties } from 'react';
import { TOOLTIP_ICON } from './SubProduct';

const tooltipButtonStyle: CSSProperties = {
  height: '16px',
  width: '16px',
  zIndex: 2,
  cursor: 'pointer',
  marginLeft: '4px',
};

const templateAdvancedTooltipStyle: CSSProperties = {
  background: '#3E2893',
  minWidth: 160,
  borderRadius: '7px',
  zIndex: '5',
  padding: '8px',
};

const templateTooltipStyle: CSSProperties = {
  background: '#3E2893',
  color: '#ffff',
  maxWidth: 220,
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  zIndex: '5',
};

export const LightningLinkMainProduct: React.FC<{
  mainProduct: any;
  salePercentage?: number;
  tooltipLoadCallback?: (arr: string[]) => Promise<IProductResponse[]>;
  tooltipOpenEventHandler?: () => void;
}> = ({
  mainProduct,
  salePercentage = 0,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
}) => {
  return (
    <StyledLightningLinkMainProduct className="main-product">
      <div className="product-img">
        <img className="image" src={mainProduct.images.product} alt="product" />
      </div>
      <div className="content-container">
        <div className="quantity-container">
          <AutoTextSize
            as="div"
            mode="oneline"
            maxFontSizePx={14}
            minFontSizePx={6}
            className="quantity-container__value"
          >
            {mainProduct.quantityDisplay}
            <TooltipRenderer
              product={mainProduct}
              tooltipLoadCallback={tooltipLoadCallback}
              tooltipOpenEventHandler={tooltipOpenEventHandler}
              advancedTooltipStyle={templateAdvancedTooltipStyle}
              simpleTooltipStyle={templateTooltipStyle}
              buttonStyle={tooltipButtonStyle}
            >
              <img
                className="tooltip-icon"
                src={TOOLTIP_ICON}
                alt="tooltip-icon"
              />
            </TooltipRenderer>
          </AutoTextSize>
        </div>
        {salePercentage > 0 && (
          <div className="stroked-container">
            <AutoTextSize
              as="div"
              mode="oneline"
              maxFontSizePx={10}
              minFontSizePx={6}
              className="stroked-container__value"
            >
              {mainProduct.strokedSaleQuantity}
            </AutoTextSize>
          </div>
        )}
      </div>
    </StyledLightningLinkMainProduct>
  );
};
